import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../../utils';

export const RepaymentApi = createAsyncThunk(
  'RepaymentApi',
  async (repaymentPayload, { dispatch }) => {
    dispatch({ type: 'RepaymentApi/pending', payload: {} });

    const { customerId, Authorization, customerRefNum } = repaymentPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerdashboard/repayment_tile',
      payload: {
        customerRefNum,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const repaymentRes = res;
        dispatch({ type: 'RepaymentApi/fulfilled', payload: repaymentRes });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'RepaymentApi/rejected', payload: err });
      },
    });
  }
);

export const RepaymentApi_extrareducer = {
  [RepaymentApi.pending]: (state, action) => {
    state.repaymentCardApiState.isLoading = true;
  },
  [RepaymentApi.fulfilled]: (state, action) => {
    state.repaymentCardApiState.isLoading = false;
    state.repaymentCardApiState.isSuccess = true;
    state.repaymentCardApiState.isError = false;
    state.repaymentCardApiState.response = action.payload;
  },
  [RepaymentApi.rejected]: (state, action) => {
    state.repaymentCardApiState.isLoading = false;
    state.repaymentCardApiState.isSuccess = false;
    state.repaymentCardApiState.isError = true;
    state.repaymentCardApiState.response = action.payload;
  },
};
